export default __webpack_public_path__ + "static/media/pointright.6980f6ed.png";